import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { FaBullseye, FaLightbulb, FaMapMarkerAlt, FaBirthdayCake, FaComments, FaVideo } from "react-icons/fa";
import API_URL from '../../../utils/api';
import "./DynamicProfiles.css";

export default function VideoProfiles() {
  const { sessionId } = useParams();
  const navigate = useNavigate();
  const [sessionData, setSessionData] = useState(null);
  const [loading, setLoading] = useState(true);
  const userId = sessionStorage.getItem("userId") || localStorage.getItem("userId");

  useEffect(() => {
    const fetchSession = async () => {
      try {
        const response = await fetch(`${API_URL}/api/funtellime/video-session/${sessionId}`);
        const data = await response.json();
        setSessionData(data);
        setLoading(false);
      } catch (error) {
        alert("Failed to load session data");
        navigate("/funtellime");
      }
    };

    fetchSession();
  }, [sessionId, navigate]);

  const handleStartVideo = () => {
    navigate(`/funtellime/video-room/${sessionId}`);
  };

  if (loading) {
    return (
      <div className="dynamic-profiles-container">
        <div className="loading-message">Loading profiles...</div>
      </div>
    );
  }

  const { dynamicProfile1, dynamicProfile2, isharingPrompt, similarities } = sessionData;
  const myProfile = parseInt(userId) === dynamicProfile1.user_id ? dynamicProfile1 : dynamicProfile2;
  const partnerProfile = parseInt(userId) === dynamicProfile1.user_id ? dynamicProfile2 : dynamicProfile1;

  return (
    <div className="dynamic-profiles-container">
      <div className="profiles-header">
        <h1>Your Video Match!</h1>
        <p className="profiles-subtitle">Get to know each other through these dynamic profiles</p>
      </div>

      {/* Similarities Section */}
      <div className="similarities-section">
        <div className="similarities-header">
          <FaBullseye className="similarities-icon" />
          <h2>What You Have in Common</h2>
        </div>
        <div className="similarities-list">
          {similarities.sharedInterests?.length > 0 && (
            <div className="similarity-item">
              <span className="similarity-label">Shared Interests:</span>
              <span className="similarity-value">{similarities.sharedInterests.join(", ")}</span>
            </div>
          )}
          {similarities.sameLocation && (
            <div className="similarity-item">
              <span className="similarity-label">Location:</span>
              <span className="similarity-value">Both from {myProfile.location}</span>
            </div>
          )}
          {similarities.similarAge && (
            <div className="similarity-item">
              <span className="similarity-label">Age:</span>
              <span className="similarity-value">Similar age group</span>
            </div>
          )}
        </div>
      </div>

      {/* I-Sharing Prompt */}
      <div className="isharing-prompt-section">
        <div className="isharing-header">
          <FaLightbulb className="prompt-icon" />
          <h2>Your Conversation Starter</h2>
        </div>
        <div className="isharing-prompt">
          <FaComments className="quote-icon" />
          <p>{isharingPrompt}</p>
        </div>
        <p className="prompt-instruction">
          Use this prompt to begin your video conversation and share your experiences!
        </p>
      </div>

      {/* Profile Cards */}
      <div className="profiles-grid">
        {/* My Dynamic Profile */}
        <div className="profile-card my-profile">
          <div className="profile-badge">Your Profile</div>
          <div className="profile-content">
            <h3 className="profile-name">{myProfile.name}</h3>
            
            <div className="profile-detail">
              <FaBullseye className="detail-icon" />
              <div>
                <span className="detail-label">Interests:</span>
                <span className="detail-value">{myProfile.interests?.join(", ")}</span>
              </div>
            </div>

            <div className="profile-detail">
              <FaMapMarkerAlt className="detail-icon" />
              <div>
                <span className="detail-label">Location:</span>
                <span className="detail-value">{myProfile.location}</span>
              </div>
            </div>

            <div className="profile-detail">
              <FaBirthdayCake className="detail-icon" />
              <div>
                <span className="detail-label">Age:</span>
                <span className="detail-value">{myProfile.age} years old</span>
              </div>
            </div>
          </div>
        </div>

        {/* Partner's Dynamic Profile */}
        <div className="profile-card partner-profile">
          <div className="profile-badge partner-badge">Your Match</div>
          <div className="profile-content">
            <h3 className="profile-name">{partnerProfile.name}</h3>
            
            <div className="profile-detail">
              <FaBullseye className="detail-icon" />
              <div>
                <span className="detail-label">Interests:</span>
                <span className="detail-value">{partnerProfile.interests?.join(", ")}</span>
              </div>
            </div>

            <div className="profile-detail">
              <FaMapMarkerAlt className="detail-icon" />
              <div>
                <span className="detail-label">Location:</span>
                <span className="detail-value">{partnerProfile.location}</span>
              </div>
            </div>

            <div className="profile-detail">
              <FaBirthdayCake className="detail-icon" />
              <div>
                <span className="detail-label">Age:</span>
                <span className="detail-value">{partnerProfile.age} years old</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="start-button-container">
        <button className="start-video-btn" onClick={handleStartVideo}>
          <FaVideo /> Start Video Chat
        </button>
      </div>
    </div>
  );
}
